import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): boolean {
    const token = localStorage.getItem('token');
    if (token) {
      return true;
    } 
    console.log("RouteGuard: Redirecting to /auth/sign-in");
    this.redirectTo('/auth/sign-in');
    return false;
  }
    private redirectTo(route: string): void {
      this.router.navigate([route]);
    }
  }

